import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter , Globe} from "lucide-react";
import reglogo from '../../assets/siret.jpg';
import navlogo from '../../assets/navlogo.png';

const Footer = () => {
  return (
    <footer className="bg-midnight-navy text-white" data-testid="footer">
        {/* Trust Badges Bar */}
      <div className="border-t bg-paris-stone">
        <div className="container mx-auto px-4 lg:px-6 py-6">
          <div className="flex flex-wrap justify-center gap-6 text-sm text-black/80">
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 bg-green-400 rounded-full"></span>
              Free Child Seats
            </span>
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 bg-green-400 rounded-full"></span>
              Fixed Prices
            </span>
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 bg-green-400 rounded-full"></span>
              Meet &amp; Greet
            </span>
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 bg-green-400 rounded-full"></span>
              24/7 Support
            </span>
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 bg-green-400 rounded-full"></span>
              Pay Driver on Arrival
            </span>
          </div>
        </div>
      </div>
      {/* Main Footer */}
      <div className="container mx-auto px-4 lg:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={navlogo}
                alt="Best Disney Transfer"
                className="h-8 w-auto"
              />
            </div>
            <p className="text-paris-stone/80 mb-6 leading-relaxed">
              Premium private transfer services in Paris. Safe, reliable, and comfortable 
              transportation to Disneyland, airports, and beyond.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 hover:bg-champagne-gold rounded-lg transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              {/* <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 hover:bg-champagne-gold rounded-lg transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-white/10 hover:bg-champagne-gold rounded-lg transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a> */}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4 text-champagne-gold">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/disneyland-transfers"
                  className="text-paris-stone/80 hover:text-champagne-gold transition-colors"
                >
                  Disneyland Transfers
                </Link>
              </li>
              <li>
                <Link
                  to="/airport-transfers"
                  className="text-paris-stone/80 hover:text-champagne-gold transition-colors"
                >
                  Airport Transfers
                </Link>
              </li>
              <li>
                <Link
                  to="/city-tours"
                  className="text-paris-stone/80 hover:text-champagne-gold transition-colors"
                >
                  City Tours
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-paris-stone/80 hover:text-champagne-gold transition-colors"
                >
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4 text-champagne-gold">Support</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-paris-stone/80 hover:text-champagne-gold transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-paris-stone/80 hover:text-champagne-gold transition-colors"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-paris-stone/80 hover:text-champagne-gold transition-colors"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-paris-stone/80 hover:text-champagne-gold transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-paris-stone/80 hover:text-champagne-gold transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-4 text-champagne-gold">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-champagne-gold flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-white font-medium">+33 763 519 524</p>
                  <p className="text-paris-stone/60 text-sm">24/7 Support</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-champagne-gold flex-shrink-0 mt-0.5" />
                <a
                  href="mailto:info@bestdisneytransfer.com"
                  className="text-paris-stone/80 hover:text-champagne-gold transition-colors"
                >
                  info@bestdisneytransfer.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-champagne-gold flex-shrink-0 mt-0.5" />
                <p className="text-paris-stone/80">
                  11 Square De L'avre,<br />
                  92100 Boulogne-Billancourt,<br />
                  France
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Legal Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 lg:px-6 py-4">
          <div className="flex flex-col mb-16 md:mb-0 md:flex-row justify-between items-center gap-4 text-xs text-paris-stone/60">
            <div className="flex items-center gap-4">
              <img src={reglogo} alt="Registration Logos" className="h-10  w-auto"/>
              <span>SIRET: 947 524 732  00015 </span>
              <div>
                { " "}
              </div>
              <span> RC Paris: 947 524 732</span>

            </div >
            <div className="flex items-right">
            <p>&copy; {new Date().getFullYear()} Best Disney Transfer. All rights reserved. | Designed and developed by   
              <a className="font-bold text-lg ml-1 text-champagne-gold " href="https://lithiclabs.com/" target="_blank" rel="noopener noreferrer" >
               Lithic Labs</a></p>.
          
        </div>          
        </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
